import { memo } from 'react';

import { Checkbox } from '@/components/design-system/checkbox';
import { useTranslation } from 'react-i18next';

import type { ColumnDefinition } from './ColumnPicker';

interface ColumnPickerListProps {
  columns: ColumnDefinition[];
  visibleColumns: string[];
  onToggle: (columnId: string, checked: boolean) => void;
  dataTestId: string;
}

export const ColumnPickerList = memo(function ColumnPickerList({
  columns,
  visibleColumns,
  onToggle,
  dataTestId
}: ColumnPickerListProps) {
  const { t } = useTranslation();

  if (columns.length === 0) {
    return (
      <div className="text-typography-900 px-3 py-6 text-center text-[13px] opacity-50">
        {t('grid.columnPicker.noResults')}
      </div>
    );
  }

  return (
    <div className="max-h-[280px] overflow-y-auto px-3 py-2">
      {columns.map((column) => (
        <label
          key={column.id}
          className="hover:bg-background-700 -mx-3 flex cursor-pointer items-center gap-2 px-3 py-1.5 select-none"
        >
          <Checkbox
            checked={visibleColumns.includes(column.id)}
            onCheckedChange={(checked) => {
              onToggle(column.id, checked === true);
            }}
            data-testid={`${dataTestId}-checkbox-${column.id}`}
          />
          <span className="text-typography-900 flex-1 truncate text-[13px]">{column.label}</span>
        </label>
      ))}
    </div>
  );
});
